import React, { useState, useContext, useRef } from "react";
import { PhotoManagerContext } from "..";
import toastr from "../../../common/toastr";
import { DeleteShortCutPropsType } from "../types";
const alertIcon = require("../../../ManagePrepaidCustomers/components/images/alert.svg");
import { usePopupClickOutside } from "../../../../hooks/usePopupClickOutside";
import { deleteLibraryShortcut } from "../../API/api";
import { decodeEntityPath, getEncodedEntityPath } from "./EncryptionOfFolder";

const DeleteShortcut: React.FC<DeleteShortCutPropsType> = ({
  onClose,
  shortCut,
  onDeleteShortCut,
  type = "folder",
  referenceId
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const context = useContext(PhotoManagerContext);
  const [confirmationText, setConfirmationText] = useState<string | null>(null);
  const isNotConfirmed = confirmationText?.toUpperCase() !== "DELETE";

  usePopupClickOutside(popupRef as React.RefObject<HTMLElement>, () =>
    onClose()
  );

  const handleDeleteShortcut = async () => {
    if (isNotConfirmed) {
      toastr.error("Please enter DELETE to confirm");
      return;
    }

    if (referenceId) {
      const res = await deleteLibraryShortcut(referenceId);
      onClose();

      if (res.success) {
        toastr.success("Shortcut deleted successfully");
        onDeleteShortCut(shortCut);
        context?.setDeletedViewState();
        context?.removeFolderFromEncodedPath(referenceId);
      } else {
        toastr.error(res.error);
      }
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleDeleteShortcut();
    }
  };
  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in geo-modal geo-modal--small"
        role="dialog"
      >
        <div
          className="modal-dialog filter-dialog-content delete-folder-modal"
          ref={popupRef}
        >
          <div className="geo-modal__header geo-modal--warning-bg geo-del-header">
            <img
              className="delete-modal-warn-icon"
              src={alertIcon}
              alt="exclamation-warn"
            />
            <div className="delete-modal-header">Are you sure?</div>
          </div>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="modal-content">
            <p className="delete-modal-info">
              {type === "folder"
                ? "This shortcut will be deleted, all the actual folder and events in it will still exist,"
                : "This shortcut will be deleted, all the actual albums in it will still exist,"}{" "}
              please type DELETE to confirm.
            </p>

            <div className="modal-footer delete-folder-footer">
              <div className="geo geo-form geo-form--fw delete-input">
                <input
                  id="name-input"
                  type="text"
                  className="geo-form__input ws-geo-input"
                  value={confirmationText || ""}
                  onChange={e => {
                    e.stopPropagation();
                    setConfirmationText(e.target.value);
                  }}
                  onKeyPress={e => {
                    handleKeyPress(e);
                  }}
                  placeholder="DELETE"
                  autoFocus
                  disabled={loading}
                />
              </div>
              <button
                className="geo-btn geo-btn--secondary geo-btn--caps geo-btn--small delete-folder-btn"
                onClick={() => {
                  handleDeleteShortcut();
                }}
                disabled={loading || isNotConfirmed}
              >
                {loading ? (
                  <div className="loading-spinner">
                    Deleting..<span className="fa fa-spinner fa-spin"></span>
                  </div>
                ) : (
                  "I understand, continue"
                )}
              </button>
              <button
                className="geo-btn geo-btn--link geo-btn--caps delete-cancel-button"
                onClick={onClose}
              >
                No, Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default DeleteShortcut;
